import lottie from 'lottie-web';
import inView from 'in-view';

export function initLottie() {
    const images = document.querySelectorAll('#lottie');

    images.forEach((image) => {
        lottieAnimate(image);
    });
}

function lottieAnimate(element) {
    const imgPath = element.getAttribute('data-path');
    const loop =  element.getAttribute('data-animate-loop') ?? false;
    const animateOn = element.getAttribute('data-animate-on') ?? 'load';
    let looping = false;

    if (loop === 'true') {
        looping = true;
    }

    const animation = lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: looping ?? false,
        autoplay: false,
        path: imgPath,
    });
    if (animateOn === 'load') {
        setTimeout(function () {
            animation.play();
        }, 300);
    }
    else if (animateOn === 'mouseenter') {
        animation.goToAndStop(90, true);
        element.addEventListener('mouseenter', function () {
            animation.goToAndPlay(0, true);
        });
    }
    else if (animateOn === 'inview') {
        inView('#lottie')
            .on('enter', function (el) {
                animation.play();
            })
            .on('exit', function (el) {
                animation.stop();
            });
    }
    element.classList.add('lottie-activated');
}
